const FRONT_FIXED_CAP_RATIO = 0.28;

function getDeformedFrontY(originalY, source, target) {
  if (originalY <= source.bottomCapTopY) {
    return target.minY + ((originalY - source.minY) * target.capScale);
  }

  if (originalY >= source.topCapBottomY) {
    return target.maxY - ((source.maxY - originalY) * target.capScale);
  }

  const middleRatio = (originalY - source.bottomCapTopY) / source.middleHeight;
  return target.bottomCapTopY + (middleRatio * target.middleHeight);
}

export function resizeFrontGeometryY(mesh, targetHeightLocal) {
  const originalPositions = mesh.userData.origGeometryPositions;
  const position = mesh.geometry && mesh.geometry.attributes && mesh.geometry.attributes.position;
  const sourceMinY = mesh.userData.origGeometryMinY;
  const sourceMaxY = mesh.userData.origGeometryMaxY;
  const sourceHeight = sourceMaxY - sourceMinY;

  if (!originalPositions || !position || !position.array || !sourceHeight || sourceHeight <= 0 || targetHeightLocal <= 0) {
    return false;
  }

  const sourceCapHeight = sourceHeight * FRONT_FIXED_CAP_RATIO;
  const targetCapHeight = Math.min(sourceCapHeight, targetHeightLocal * 0.45);
  const source = {
    minY: sourceMinY,
    maxY: sourceMaxY,
    bottomCapTopY: sourceMinY + sourceCapHeight,
    topCapBottomY: sourceMaxY - sourceCapHeight,
    middleHeight: sourceHeight - (sourceCapHeight * 2),
  };
  const target = {
    minY: sourceMinY,
    maxY: sourceMinY + targetHeightLocal,
    bottomCapTopY: sourceMinY + targetCapHeight,
    topCapBottomY: sourceMinY + targetHeightLocal - targetCapHeight,
    middleHeight: targetHeightLocal - (targetCapHeight * 2),
    capScale: targetCapHeight / sourceCapHeight,
  };

  if (source.middleHeight <= 0 || target.middleHeight < 0) {
    return false;
  }

  for (let index = 0; index < originalPositions.length; index += 3) {
    position.array[index] = originalPositions[index];
    position.array[index + 1] = getDeformedFrontY(originalPositions[index + 1], source, target);
    position.array[index + 2] = originalPositions[index + 2];
  }

  position.needsUpdate = true;
  mesh.geometry.computeVertexNormals();
  mesh.geometry.computeBoundingBox();
  mesh.geometry.computeBoundingSphere();

  return true;
}
